/**
 * Internal Dependencies
 */
import initializer from './initializer';

/**
 * Styles
 */
import "../scss/main.scss";

// When the DOM is ready, initialize our components.
document.addEventListener('DOMContentLoaded', () => {
	// Initialize all dynamic components (modals, back to top, etc.)
	initializer.init();
});
